export const environment = {
  production: false,
  console: true,
  API_URL: 'https://apipre.apiacpos.com/2_11_0_bridge_alh_butacas/',
  API_URL_MS: 'https://apipre.apiacpos.com/WEBAPICoreBridge_1_3_0/',
  numSerie: 'WEBAN$A$l06$A$GULAR$A$AM3[jC)',
  chClaveEmpresa: 'ALHAMBRA',
  chNombreProyecto: 'VENTAONLINE',
  chEntornoConexion: 'PREPRODUCCION',
  chOrigenConexion: 'INTERNET',
  chPasarelaEntorno: 'PREPRODUCCION',
  pasarelaRedsys: 'PREPRODUCCION',
  pasarelaPhoneSell: 'PHONE_M_PRE',
  pasarelaEntornoPhoneSell: 'CONSULTA_PRE',
  pasarelaPaypal: 'PAYPAL_PRE',
  URLOK: 'https://reservasbutacas.iacpospre.com/thankyou',
  URLKO: 'https://reservasbutacas.iacpospre.com/thankko',
  URL: 'https://reservasbutacas.iacpospre.com/',
  siteKey: '6LfXS2IUAAAAADr2WUPQDzAnTEbSQzE1Jxh0Zi0a',
  siteKeyV3: '6LcC6uYpAAAAAKWKAGoaja5hIXbOSboGL7UssUnw',
  timer: 20,
  showCaptcha: true
};
